import { escapeHtml } from '../util.js';

export function buildDropdown({ items, selectedId, placeholder, searchPlaceholder, triggerIcon, onSelect, autoOpen }) {
  const dd = document.createElement('div');
  dd.className = 'dropdown';
  const selected = selectedId ? items.find(i => i.id === selectedId) : null;
  if (selected) dd.classList.add('has-value');

  const trigger = document.createElement('button');
  trigger.className = 'dropdown-trigger';
  trigger.type = 'button';
  trigger.innerHTML = `
    <div class="trigger-icon">${triggerIcon}</div>
    <div class="trigger-text">
      <div class="trigger-label">${selected ? escapeHtml(selected.name) : escapeHtml(placeholder)}</div>
      ${selected && selected.meta ? `<div class="trigger-sub">${selected.meta}</div>` : ''}
    </div>
    <div class="trigger-caret">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
    </div>
  `;
  dd.appendChild(trigger);

  const panel = document.createElement('div');
  panel.className = 'dropdown-panel';

  const showSearch = items.length > 5;
  if (showSearch) {
    const search = document.createElement('div');
    search.className = 'dropdown-search';
    search.innerHTML = `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
      <input type="text" placeholder="${escapeHtml(searchPlaceholder)}" />
    `;
    panel.appendChild(search);
  }

  const optionsList = document.createElement('div');
  optionsList.className = 'dropdown-options';
  panel.appendChild(optionsList);

  function renderOptions(q = '') {
    const filtered = q
      ? items.filter(i => i.name.toLowerCase().includes(q.toLowerCase()) ||
                          (i.searchHint && i.searchHint.toLowerCase().includes(q.toLowerCase())))
      : items;
    optionsList.innerHTML = '';
    if (filtered.length === 0) {
      const empty = document.createElement('div');
      empty.className = 'dropdown-empty';
      empty.textContent = q ? `"${q}"와 일치하는 항목이 없습니다` : '항목이 없습니다';
      optionsList.appendChild(empty);
      return;
    }
    filtered.forEach(item => {
      const opt = document.createElement('div');
      opt.className = 'dropdown-option' + (item.id === selectedId ? ' selected' : '');
      opt.innerHTML = `
        <div class="opt-icon">${item.icon || ''}</div>
        <div class="opt-info">
          <div class="opt-name">${escapeHtml(item.name)}</div>
          ${item.meta ? `<div class="opt-meta">${item.meta}</div>` : ''}
        </div>
        <div class="opt-check">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
        </div>
      `;
      opt.addEventListener('click', (e) => {
        e.stopPropagation();
        closeDropdown();
        onSelect(item);
      });
      optionsList.appendChild(opt);
    });
  }
  renderOptions();

  if (showSearch) {
    panel.querySelector('input').addEventListener('input', (e) => renderOptions(e.target.value));
    panel.querySelector('input').addEventListener('click', (e) => e.stopPropagation());
  }

  dd.appendChild(panel);

  function openDropdown() {
    document.querySelectorAll('.dropdown.open').forEach(el => { if (el !== dd) el.classList.remove('open'); });
    dd.classList.add('open');
    // Mark modal-body so other elements can dim/become non-interactive
    const modalBody = dd.closest('.modal-body');
    if (modalBody) modalBody.classList.add('dropdown-active');

    // Measure after layout settles (handles reveal animation + DOM layout)
    const measureAndSize = () => {
      const container = dd.closest('.modal-body') || document.body;
      const triggerRect = trigger.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();
      // Panel sits 4px below trigger; leave 16px breathing room before container edge
      const availSpace = containerRect.bottom - triggerRect.bottom - 4 - 16;
      // Account for search bar inside panel (~48px) if present
      const searchHeight = showSearch ? 48 : 0;
      const optionsMaxH = Math.max(120, availSpace - searchHeight);
      optionsList.style.maxHeight = optionsMaxH + 'px';
    };
    // Wait two frames so any reveal animation finishes laying out
    requestAnimationFrame(() => requestAnimationFrame(measureAndSize));

    if (showSearch) setTimeout(() => panel.querySelector('input')?.focus(), 50);
  }
  function closeDropdown() {
    dd.classList.remove('open');
    // Clear dropdown-active if no other dropdown is open
    const modalBody = dd.closest('.modal-body');
    if (modalBody && !modalBody.querySelector('.dropdown.open')) {
      modalBody.classList.remove('dropdown-active');
    }
    if (showSearch) {
      const inp = panel.querySelector('input');
      if (inp) inp.value = '';
      renderOptions();
    }
  }
  trigger.addEventListener('click', (e) => {
    e.stopPropagation();
    if (dd.classList.contains('open')) closeDropdown();
    else openDropdown();
  });

  // Auto-open after insertion (e.g. stacked step picker)
  if (autoOpen) {
    requestAnimationFrame(() => openDropdown());
  }

  return dd;
}

document.addEventListener('click', (e) => {
  if (!e.target.closest('.dropdown')) {
    document.querySelectorAll('.dropdown.open').forEach(el => el.classList.remove('open'));
    document.querySelectorAll('.modal-body.dropdown-active').forEach(el => el.classList.remove('dropdown-active'));
  }
});
